/**
 * @generated SignedSource<<e62c0f3ed48d756675d95fa3d99da359>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ChangeStatusQuery$variables = {
  changeLocator: string;
};
export type ChangeStatusQuery$data = {
  readonly change: {
    readonly status: {
      readonly finishedBuilds: number | null | undefined;
      readonly pendingBuildTypes: number | null | undefined;
      readonly runningBuilds: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ChangeStatusQuery = {
  response: ChangeStatusQuery$data;
  variables: ChangeStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "changeLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "changeLocator",
    "variableName": "changeLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ChangeStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedBuilds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "runningBuilds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingBuildTypes",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Change",
        "kind": "LinkedField",
        "name": "change",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Change",
        "kind": "LinkedField",
        "name": "change",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0de29f6142b45b2d65001450db23d0cd",
    "id": null,
    "metadata": {},
    "name": "ChangeStatusQuery",
    "operationKind": "query",
    "text": "query ChangeStatusQuery(\n  $changeLocator: String!\n) {\n  change(changeLocator: $changeLocator) {\n    status {\n      finishedBuilds\n      runningBuilds\n      pendingBuildTypes\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "45c6462faae827da490ad8866619c360";

export default node;
